import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Sales/api/Prices");
    },
    create({ commit, dispatch }, model) {
      return ajax.post("Sales/api/Prices", model);
    },
    update({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/Prices", model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
